import 'zone.js';
import 'core-js/features/array/at';
import 'core-js/features/string/replace-all';
import 'core-js/features/object/has-own';